// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("../InterfaceBtwnRecordingAndPlayback.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "tabRef",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
              ],
              [
                "windowRef",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "title",
                Decco.optionToJson(Decco.stringToJson, v.title)
              ],
              [
                "maybeOpenerTab",
                Decco.optionToJson(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, v.maybeOpenerTab)
              ],
              [
                "viaHistoryApi",
                Decco.boolToJson(v.viaHistoryApi)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
  if (tabRef.TAG === /* Ok */0) {
    var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
    if (windowRef.TAG === /* Ok */0) {
      var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
      if (url.TAG === /* Ok */0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */0) {
          var maybeOpenerTab = Decco.optionFromJson(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeOpenerTab"), null));
          if (maybeOpenerTab.TAG === /* Ok */0) {
            var viaHistoryApi = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viaHistoryApi"), null));
            if (viaHistoryApi.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        tabRef: tabRef._0,
                        windowRef: windowRef._0,
                        url: url._0,
                        title: title._0,
                        maybeOpenerTab: maybeOpenerTab._0,
                        viaHistoryApi: viaHistoryApi._0
                      }
                    };
            }
            var e = viaHistoryApi._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".viaHistoryApi" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = maybeOpenerTab._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".maybeOpenerTab" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = title._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".title" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".url" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = windowRef._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".windowRef" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = tabRef._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tabRef" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stringify(param) {
  var maybeOpenerTab = param.maybeOpenerTab;
  return "{tabRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(param.tabRef) + (", windowRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(param.windowRef) + (", url: " + (StringUtils$SmartcutsMacros.quote(param.url) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + (", openerTab: " + ((
                            maybeOpenerTab !== undefined ? InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(maybeOpenerTab) : "undefined"
                          ) + (", viaHistoryApi: " + (Pervasives.string_of_bool(param.viaHistoryApi) + "')")))))))))));
}

var CommandValue = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

exports.CommandValue = CommandValue;
/* StringUtils-SmartcutsMacros Not a pure module */
